import { analysisClient, supabase } from "@/shared/lib/supabase";
import { isSupabaseUserNotFoundError } from "@/shared/lib/supabase-auth-errors";

export async function getGlobalTenantId(): Promise<string | null> {
  const { data, error } = await analysisClient
    .from("tenant")
    .select("tenant_id")
    .eq("tenant_name", "Global")
    .single();

  if (error) return null;
  return data.tenant_id;
}

export async function getUserTenantId(): Promise<string> {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError) {
    if (isSupabaseUserNotFoundError(userError)) {
      await supabase.auth.signOut();
      throw new Error("Not authenticated");
    }
    throw userError;
  }

  if (!user) throw new Error("Not authenticated");

  const { data: tenantUser, error } = await analysisClient
    .from("tenant_user")
    .select("tenant_id")
    .eq("auth_user_id", user.id)
    .single();

  if (error) throw error;
  return tenantUser.tenant_id;
}
